import { gsap } from "./gsap.js";
import { defineElement } from "./gw.js";
class TickerList extends HTMLElement {
  constructor() {
    super();
    this.isRunning = false;
    this.speed = this.getAttribute("data-speed") ?? 50;
    this.wrapperClass = this.dataset.wrapperClass ?? "ticker__items";
    this.appendHeightToHtml = this.dataset.appendHeightToHtml ?? false;
    this.clone();
    this.animate();
    this.onMouseEnter = this.pause.bind(this);
    this.onMouseLeave = this.play.bind(this);
  }

  connectedCallback() {
    this.addEventListener("mouseenter", this.onMouseEnter);
    this.addEventListener("mouseleave", this.onMouseLeave);
    this.observe();
    if (this.appendHeightToHtml) {
      document.documentElement.style.setProperty(
        "--s-announcement-height",
        `${this.offsetHeight}px`,
      );
    }
  }

  disconnectedCallback() {
    this.removeEventListener("mouseenter", this.onMouseEnter);
    this.removeEventListener("mouseleave", this.onMouseLeave);
    this.observer.disconnect();
  }

  observe() {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.play();
        } else {
          this.pause();
        }
      },
      {
        rootMargin: "200px 0px",
      },
    );
    this.observer.observe(this);
  }

  clone() {
    const originalNodes = Array.from(this.childNodes);
    const fragment = document.createDocumentFragment();
    const tempWrapper = document.createElement("div");
    tempWrapper.className = this.wrapperClass;
    tempWrapper.style.position = "absolute";
    tempWrapper.style.visibility = "hidden";
    tempWrapper.style.whiteSpace = "nowrap";
    originalNodes.forEach((node) => {
      tempWrapper.appendChild(node.cloneNode(true));
    });
    document.body.appendChild(tempWrapper);
    const contentWidth = tempWrapper.offsetWidth;
    document.body.removeChild(tempWrapper);
    if (contentWidth <= 0) {
      console.warn("Ticker content has no width, skipping animation");
      return;
    }
    const viewportWidth = window.innerWidth;
    const targetWidth = viewportWidth * 1.5;
    const minClones = Math.max(4, Math.ceil(targetWidth / contentWidth));
    for (let i = 0; i < Math.min(minClones, 5); i++) {
      const wrapper = document.createElement("div");
      wrapper.className = this.wrapperClass;
      wrapper.setAttribute("data-ticker-items", "");
      originalNodes.forEach((node) => {
        wrapper.appendChild(node.cloneNode(true));
      });
      fragment.appendChild(wrapper);
    }
    this.textContent = "";
    this.appendChild(fragment);
  }

  animate() {
    if (!this.querySelector("[data-ticker-items]")) {
      console.warn("Ticker content has no width, skipping animation");
      return;
    }
    this.contentWidth = this.querySelector("[data-ticker-items]").offsetWidth;
    this.duration = this.contentWidth / this.speed;
    this.tween = gsap.to(this.querySelectorAll("[data-ticker-items]"), {
      duration: this.duration,
      xPercent: -100,
      ease: "none",
      repeat: -1,
      onStart: () => {
        gsap.to(this, {
          duration: 0.35,
          opacity: 1,
          ease: "power2.inOut",
        });
      },
    });
    this.isRunning = true;
  }

  play() {
    this.tween.play();
  }

  pause() {
    this.tween.pause();
  }
}
defineElement("ticker-list", TickerList);
